import { NoNav } from '@/layouts'
import { requiresAuthNoAlert } from '@/lib/auth'

export default [
  {
    path: '/wizard',
    component: NoNav,
    beforeEnter: requiresAuthNoAlert,
    children: [
      {
        name: 'wizard',
        path: '',
        component: () => import('@/views/Wizard/Step0'),
      },
      {
        name: 'wizard1',
        path: 'step1',
        component: () => import('@/views/Wizard/Step1'),
      },
      {
        name: 'wizard2',
        path: 'step2',
        component: () => import('@/views/Wizard/Step2'),
      },
      {
        name: 'wizard3',
        path: 'step3',
        component: () => import('@/views/Wizard/Step3'),
      },
    ],
  },
  { 
    path: '/alerts',
    component: NoNav,
    children: [
      {
        name: 'alerts/accept',
        path: 'accept',
        component: () => import('@/views/Alerts/Accept'),
      },
      {
        name: 'alerts/payment_method',
        path: 'payment_method',
        component:  () => import('@/views/Alerts/PaymentMethod'),
      },
      {
        name: 'alerts/needs_setup',
        path: 'activate',
        component: () => import('@/views/Wizard/Step0'),
      },
    ],
  },
]